import { render, staticRenderFns } from "./CreateGroupHeader.vue?vue&type=template&id=7342786a&scoped=true&"
import script from "./CreateGroupHeader.vue?vue&type=script&lang=ts&"
export * from "./CreateGroupHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CreateGroupHeader.vue?vue&type=style&index=0&id=7342786a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7342786a",
  null
  
)

export default component.exports